import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Countdown from "@/components/Countdown";
import RoadToCurry from "@/components/RoadToCurry";
import Wishlist from "@/components/Wishlist";
import GiftCards from "@/components/GiftCards";
import CashApp from "@/components/CashApp";
import Postcards from "@/components/Postcards";
import MessageWall from "@/components/MessageWall";
import FootballWall from "@/components/FootballWall";
import EventsCalendar from "@/components/EventsCalendar";
import ThankYouWall from "@/components/ThankYouWall";
import Footer from "@/components/Footer";
import MusicToggle from "@/components/MusicToggle";

const Home = () => (
  <div className="bg-zinc-950 text-white noise-overlay">
    <Navbar />
    <Hero />
    <Countdown />
    <RoadToCurry />
    <Wishlist />
    <GiftCards />
    <CashApp />
    <FootballWall />
    <Postcards />
    <MessageWall />
    <EventsCalendar />
    <ThankYouWall />
    <Footer />
    <MusicToggle />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors theme="dark" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
